import environment from "src/utils/environment";

const log = window.require("electron-log");
const Sentry = window.require("@sentry/electron");
const remote = window.require("@electron/remote");

const { systemPreferences, shell } = remote;

const { isMacOs, isWindows } = environment;

export default function createPermissions() {
  return {
    getMediaAccessStatus: async (mediaType) => {
      if (isMacOs || isWindows) {
        const status = await systemPreferences.getMediaAccessStatus(mediaType);
        if (isWindows && status !== "granted") {
          Sentry.captureMessage(`Windows ${mediaType} media access status was not "granted" but "${status}".`);
        }
        return status;
      }

      return "granted";
    },
    resolveMediaPermission: async (mediaType) => {
      if (!isMacOs && !isWindows) return true;

      // Returns String - Can be not-determined, granted, denied, restricted or unknown.
      const status = await systemPreferences?.getMediaAccessStatus(mediaType);

      if (status === "granted") return true;

      if (isWindows) {
        Sentry.captureMessage(`Windows ${mediaType} media access status was not "granted" but "${status}".`);
        return false;
      }

      if (status === "not-determined") {
        return await systemPreferences.askForMediaAccess(mediaType);
      }
      return false;
    },
    openSettings: async (mediaType) => {
      try {
        if (isMacOs) {
          await shell.openExternal(
            `x-apple.systempreferences:com.apple.preference.security?Privacy_${
              mediaType === "microphone" ? "Microphone" : "Camera"
            }`
          );
        } else if (isWindows) {
          await shell.openExternal(`ms-settings:privacy-${mediaType === "microphone" ? "microphone" : "webcam"}`);
        }
      } catch (err) {
        log.error(err);
      }
    },
    askForMediaAccess: async (mediaType) => {
      return await systemPreferences.askForMediaAccess(mediaType);
    }
  };
}
